import { Component, Inject, OnInit } from '@angular/core';
import { BannerNotificationService } from '../../services/banner-notification.service';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Component({
  selector: 'banner-notification',
  standalone: false,
  templateUrl: './banner-notification.component.html',
  styleUrl: './banner-notification.component.scss',
})
export class BannerNotificationComponent implements OnInit {
  banner: app.models.BannerNotificationModel | null = null;
  androidLink: string;
  iosLink: string;

  constructor(
    private _bannerService: BannerNotificationService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData
  ) {
    this.androidLink = this._envConfig.ANDROID_MOBILE_LINK;
    this.iosLink = this._envConfig.IOS_MOBILE_LINK;
  }

  ngOnInit() {
    this._bannerService.banner$.subscribe(data => {
      this.banner = data;
    });
  }

  close() {
    this._bannerService.hideBannerNotification();
  }
}
